<template><span hidden aria-hidden="true"></span></template>
<script>
import { canonicalPath, isIndexableRoute, siteOrigin } from '@/utils/seoPolicy.mjs'
export default {
  props: { title: String, description: String, keywords: String, image: String, structuredData: Object },
  computed: {
    fullCanonicalUrl() { return siteOrigin(process.env.VUE_APP_SITE_URL || 'https://www.kamsled.com') + canonicalPath(this.$route) },
    headState() {
      return { title: this.title, description: this.description, keywords: this.keywords,
        image: this.image, schema: this.structuredData, url: this.fullCanonicalUrl,
        robots: isIndexableRoute(this.$route) ? 'index, follow' : 'noindex, follow' }
    }
  },
  watch: { headState: { deep: true, handler() { this.updateHead() } } },
  mounted() { this.updateHead() },
  beforeDestroy() { document.head.querySelectorAll('[data-kams-seo]').forEach(node => node.remove()) },
  methods: {
    updateHead() {
      const state = this.headState
      document.title = state.title || 'KAMS LED'
      document.head.querySelectorAll('[data-kams-seo]').forEach(node => node.remove())
      const add = (tag, attrs, text) => {
        const node = document.createElement(tag)
        node.setAttribute('data-kams-seo', '')
        Object.entries(attrs).forEach(([key, value]) => node.setAttribute(key, value))
        if (text) node.textContent = text
        document.head.appendChild(node)
      }
      for (const [name, content] of Object.entries({ description: state.description, keywords: state.keywords, robots: state.robots, author: 'KAMS LED', 'twitter:card': 'summary_large_image', 'twitter:title': state.title, 'twitter:description': state.description, 'twitter:image': state.image, 'twitter:url': state.url })) {
        if (content) add('meta', { name, content })
      }
      for (const [property, content] of Object.entries({ 'og:type': 'website', 'og:url': state.url, 'og:title': state.title, 'og:description': state.description, 'og:image': state.image, 'og:site_name': 'KAMS LED' })) {
        if (content) add('meta', { property, content })
      }
      add('link', { rel: 'canonical', href: state.url })
      add('script', { type: 'application/ld+json' }, JSON.stringify(state.schema || { '@context': 'https://schema.org', '@type': 'WebPage', name: state.title || '', url: state.url }))
    }
  }
}
</script>
